<template>
    <div class="post-card">
        <div class="header" :id="'id' + item._id">
            <div v-if="parseInt(loggedInUser.user_id) === 0" class="delete_tip" style="">
                <button  type="button" aria-label="Close" class="close" @click="handleDeleteTip(item._id )"><span aria-hidden="true">×</span></button>
            </div>
            <div class="posted_date_mb">
                <div class="header-item second_line_left_hidden">
                    <div class="avatar_container_mb">
                        <div class="avatar_subcontainer_mb">
                            <avatar :key="item._id" :size="50" :username="item.userName" :src="item.userAvatar" :userId="item.userId"
                                class="feed_avatar" />
                        </div>
                    </div>
                    <div class="avatar_right_letters">
                        <CLink :to="{name: 'UserTipStat', params: {id: item.userId}}">
                            <span :key="item.online_refreshKey" :class="{'online-mark' : item.online, 'offline-mark' : !item.online}"></span>{{ item.userName }}
                            <!--gretprete-->
                        </CLink>
                        <div v-if="item.roi !== undefined && item.total_tips !== undefined" class="under_user_name">
                            &ensp;{{ item.roi }}%
                            ({{ item.total_tips }} tips)
                        </div>
                        <span class="unread-mark" v-if="unread"></span>
                    </div>
                </div>
                
                <div>                    
                    {{ $t('Posted') }}: {{item.dateTime}}
                </div>
                <hr class="hr_underpost">
            </div>
            
            <div class="feed_page_second_line">
                <div class="header-item second_line_left" style="width: 25%; text-align: center; display: block; position: relative;">
                   <div style="position: absolute; top: 50%; left: 50%; display: block; transform: translate(-50%, -50%); text-align: center; width: 100%;">
                        <div class="avatar_subcontainer" style="text-align:center; display: block; margin: 0 auto; ">
                            <avatar :size="100" :username="item.userName" :src="item.userAvatar" :userId="item.userId"
                                class="feed_avatar"/>
                        </div>
                        <CLink :to="{name: 'UserTipStat', params: {id: item.userId}}" class="avatar_link">
                            <span :key="item.online_refreshKey" :class="{'online-mark' : item.online, 'offline-mark' : !item.online}"></span>{{ item.userName }}
                            <!--gretprete-->
                        </CLink>

                        <div v-if="item.roi !== undefined && item.total_tips !== undefined" style="display: block;" class="avatar_link_under">
                            &ensp;{{ item.roi }}%
                            ({{ item.total_tips }} tips)
                        </div>
                        <span class="unread-mark" v-if="unread"></span>
                    </div>
                </div>
                <div class="second_line_right" >
                    <div class="header-item second_right_first">
                        <div class="bold_head">
                            <strong>{{item.eventName}}</strong>
                        </div>
                        <div class="public">
                             {{  $t(capitalizeVisibility(item.visibility) )}}
                        </div>
                    </div>
                    <div v-if="item.visible || item.userId === parseInt(loggedInUser.user_id)  || parseInt(loggedInUser.user_id) === 0" class="header-item">
                        <div class="tips_font18">
                            <span style="color: blue;">{{ $t('Tips') }}</span>:&nbsp;{{item.predictionType.replace(/ - /g, ' ').replace('Double chance', 'DC').replace('Draw no bet', 'DNB')}} &nbsp;
                            <span style="color: blue;">{{ $t('Odd') }}</span>:&nbsp;{{item.odd}} &nbsp;
                            <span style="color: blue;">{{ $t('Stake pts') }}</span>:&nbsp;{{item.stake}} &nbsp;
                            <!-- {{item.settled === 0 ? 'Pending' : data.settled === 1 ? 'Won' : 'Lose'}} -->
                            <span style="color: blue;" v-if="item.status.split(/\s+/).length > 1">{{item.status.split(/\s+/)[0] + ' ' + item.status.split(/\s+/)[1]}}</span>
                            <span style="color: blue;" v-else>{{item.status}}</span> &nbsp;
                            <span>({{item.score}})</span>
                        </div>
                    </div>

                    <div v-if="(item.visible || item.userId === parseInt(loggedInUser.user_id)  || parseInt(loggedInUser.user_id) === 0) && item.cover_predictionType" class="header-item">
                        <div class="tips_font18">
                            <span style="color: blue;">Cover</span>:&nbsp;{{item.cover_predictionType.replace(/ - /g, ' ').replace('Double chance', 'DC').replace('Draw no bet', 'DNB')}} &nbsp;
                            <span style="color: blue;">{{ $t('Odd') }}</span>:&nbsp;{{item.cover_odd}} &nbsp;
                            <span style="color: blue;">{{ $t('Stake pts') }}</span>:&nbsp;{{item.cover_stake}} &nbsp;
                            <!-- {{item.settled === 0 ? 'Pending' : data.settled === 1 ? 'Won' : 'Lose'}} -->
                            <span style="color: blue;" v-if="item.status.split(/\s+/).length > 1">{{item.status.split(/\s+/)[0] + ' ' + item.status.split(/\s+/)[1]}}</span>
                            <span style="color: blue;" v-else>{{item.status}}</span> &nbsp;
                            <span>({{item.score}})</span>
                        </div>
                    </div>

                    <div class="header-item">
                        {{item.country}} -
                        {{item.league}} -
                        {{item.startingAt}}
                    </div>
                    
                    <!-- strategy  -->
                    <div v-if="(item.visible || item.userId === parseInt(loggedInUser.user_id) || parseInt(loggedInUser.user_id) === 0) && item.strategyData" class="right_bottom">
                        <strong>{{ $t('Strategy') }}:&nbsp;</strong>
                        <router-link :to="{name: 'UserStrategyStat', params: {id: item.strategyData._id, userId: loggedInUser.user_id}}">
                            {{ item.strategyData.name}}
                        </router-link> [
                        <span v-if="item.strategyStat.totalCount">
                            {{ item.strategyStat.stakeTotal ? (item.strategyStat.profitPTS /
                            item.strategyStat.stakeTotal * 100).toFixed(2) : 0, }}%
                            ({{ item.strategyStat.totalCount }} tips) ]
                        </span>
                        <div class="action-box" :key="item.strategyData.followers.length">
                            <div
                                :class="{'action': true, 'selected': item.strategyData.followers.includes(parseInt(loggedInUser.user_id))}">
                                {{item.strategyData.followers.length}}
                                <span v-if="item.strategyData.userId !== parseInt(loggedInUser.user_id)"
                                    v-c-tooltip="!item.strategyData.followers.includes(parseInt(loggedInUser.user_id)) ? 'Follow this strategy':'You already followed this strategy'"
                                    @click="handleFollowStrategy(item._id)">
                                    <CIcon name="cil-user-follow" />
                                </span>
                                <span v-else>
                                    <CIcon name="cil-user-follow" class="disabled" />
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- cash out -->
                    <div v-if="item.fixture && 
                        item.fixture.length > 0 && 
                        item.settled === 0 
                        " class="cash-out mt-2 parent_cash_out_details">
                        <div v-if="item.cashout === undefined">
                            <div class="cash_out_details">
                                <span>{{ $t('Cash out details') }}:</span>
                                <span v-if="item.userId === parseInt(loggedInUser.user_id)" v-b-modal="item._id" class="auto_cashout">{{ $t('Auto') }}</span>
                            </div>
                            <div class="header-item">
                                <div class="cash_out_cell">
                                    Tip: 
                                    {{item.currentStatus}} -
                                    {{item.currentScore}} -
                                    Odd: {{item.currentOdd}}
                                </div>
                                <div style="float:right">
                                    <span class="modile_hide cash_out_cell">{{ $t('Current profit') }}:&nbsp;</span>
                                    <span v-if="item.currentPointProfit !== ''" :class="{
                                        'settled-won cash_out_cell': item.currentPointProfit > 0,
                                        'settled-void cash_out_cell': item.currentPointProfit == 0,
                                        'settled-lost cash_out_cell': item.currentPointProfit < 0}">{{item.currentPointProfit}}</span>
                                    <span v-else class="cash_out_cell"><span class="modile_hide">Not available</span><span class="desktop_hide cash_out_cell">N/A</span></span>
                                    <div v-if="isMe" style='margin-left: 10px;'>                            
                                        <div>
                                            <CButton block color="warning" class="d-flex align-items-center cashout_button" @click="onCashOut(item._id, 0, false)"
                                                :disabled="!item.currentOdd || item.currentOdd_suspended || loading || item.currentPointProfit === ''">
                                                Cash Out {{item.cashOut}}                                                
                                                <CSpinner v-if="loading" color="danger" size="sm" />
                                            </CButton>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div v-else>
                            <div class="cash_out_details">
                                <span>{{ $t('Cash out details') }}:</span>
                                <span v-if="item.userId === parseInt(loggedInUser.user_id)" v-b-modal="item._id" class="auto_cashout">{{ $t('Auto') }}</span>
                            </div>
                            <div class="header-item cash_out_details">
                                <div>

                                    {{ $t('Tip Cash Out') }}:
                                    {{item.cashoutStatus}} -
                                    {{item.cashoutScore}} -
                                    Odd: {{item.cashoutOdd}}
                                </div>
                                <div style="float: right">
                                    PTS:&nbsp;
                                    <span :class="{
                                        'settled-won': item.profitPts > 0,
                                        'settled-void': item.profitPts == 0,
                                        'settled-lost': item.profitPts < 0,
                                    }">{{item.profitPts}}</span>
                                </div>
                            </div>                            
                        </div>
                        <div v-if="item.cover_cashOut_flag">
                            <div v-if="!item.cover_cashout" style="margin-top: 5px;">                            
                                <div class="header-item">
                                    <div class="cash_out_cell">
                                        Cover:
                                        {{item.currentStatus}} -
                                        {{item.currentScore}} -
                                        Odd: {{item.cover_currentOdd}}
                                    </div>
                                    <div style="float:right">
                                        <span class="modile_hide cash_out_cell">{{ $t('Current profit') }}:&nbsp;</span>
                                        <span v-if="item.cover_currentPointProfit !== ''" :class="{
                                            'settled-won cash_out_cell': item.cover_currentPointProfit > 0,
                                            'settled-void cash_out_cell': item.cover_currentPointProfit == 0,
                                            'settled-lost cash_out_cell': item.cover_currentPointProfit < 0}">{{item.cover_currentPointProfit}}</span>
                                        <span v-else  class="cash_out_cell"><span class="modile_hide cash_out_cell">Not available</span><span class="desktop_hide cash_out_cell">N/A</span></span>
                                        <div v-if="isMe" style='margin-left: 10px;'>                            
                                            <div>
                                                <CButton block color="warning" class="d-flex align-items-center cashout_button" @click="onCashOut(item._id, 1, false)"
                                                    :disabled="!item.cover_currentOdd || item.cover_currentOdd_suspended  || cover_loading || item.cover_currentPointProfit === ''">
                                                    Cash Out {{item.cover_cashOut}}                                                    
                                                    <CSpinner v-if="cover_loading" color="danger" size="sm" />
                                                </CButton>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div  v-else class="header-item cash_out_details">
                                <div>
                                     {{ $t('Cover Cash Out') }}:
                                    {{item.cover_cashoutStatus}} -
                                    {{item.cover_cashoutScore}} -
                                    Odd: {{item.cover_cashoutOdd}}
                                </div>
                                <div style="float: right">
                                    PTS:&nbsp;
                                    <span :class="{
                                        'settled-won': item.cover_profitPts > 0,
                                        'settled-void': item.cover_profitPts == 0,
                                        'settled-lost': item.cover_profitPts < 0,
                                    }">{{item.cover_profitPts}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- cashed out settled  -->
                    <div v-if="item.settled !== 0 && (item.cashout || item.cover_cashout)" class="parent_cash_out_details" >
                        <div v-if="item.cashout || item.cover_cashout" class="cash_out_details">
                            <span>{{ $t('Cash out details') }}:</span>
                        </div>
                        <div v-if="item.cashout" class="header-item cash_out_details">                            
                            <div>
                                {{ $t('Tip Cash Out') }}:
                                {{item.cashoutStatus}} -
                                {{item.cashoutScore}} -
                                Odd: {{item.cashoutOdd}}
                            </div>
                            <div style="float: right">
                                PTS:&nbsp;
                                <span :class="{
                                    'settled-won': item.profitPts > 0,
                                    'settled-void': item.profitPts == 0,
                                    'settled-lost': item.profitPts < 0,
                                }">{{item.profitPts}}</span>
                            </div>
                              
                        </div>
                        <div  v-if="item.cover_cashout" class="header-item cash_out_details">
                            <div>
                                {{ $t('Cover Cash Out') }}:
                                {{item.cover_cashoutStatus}} -
                                {{item.cover_cashoutScore}} -
                                Odd: {{item.cover_cashoutOdd}}
                            </div>
                            <div style="float: right">
                                PTS:&nbsp;
                                <span :class="{
                                    'settled-won': item.cover_profitPts > 0,
                                    'settled-void': item.cover_profitPts == 0,
                                    'settled-lost': item.cover_profitPts < 0,
                                }">{{item.cover_profitPts}}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="(item.visible || item.userId === parseInt(loggedInUser.user_id)  || parseInt(loggedInUser.user_id) === 0) && item.result" class="parent_cash_out_details">
                        <div class="cash_out_details">
                            <span>Result:</span>
                        </div>
                        <div> 
                            <span>{{item.result}}</span>

                            <span style="float: right">
                                {{ $t('PTS (total)') }}:&nbsp;
                                <span :class="{
                                'settled-won': item.total_profitPts > 0,
                                'settled-void': item.total_profitPts == 0,
                                'settled-lost': item.total_profitPts < 0,
                            }">{{item.total_profitPts.toFixed(2)}}</span></span>

                        
                           <!--  <span v-if="item.profitPts && item.cover_profitPts" style="float: right">
                                {{ $t('PTS (total)') }}:&nbsp;
                                <span :class="{
                                'settled-won': (item.profitPts + item.cover_profitPts) > 0,
                                'settled-void': (item.profitPts + item.cover_profitPts) == 0,
                                'settled-lost': (item.profitPts + item.cover_profitPts) < 0,
                            }">{{(item.profitPts + item.cover_profitPts).toFixed(2)}}</span></span>
                               
                            
                            <span v-else-if="item.profitPts" style="float: right">
                                {{ $t('PTS (total)') }}:&nbsp;
                                <span :class="{
                                'settled-won': item.profitPts > 0,
                                'settled-void': item.profitPts == 0,
                                'settled-lost': item.profitPts < 0,
                            }">{{item.profitPts}}</span></span>
                               
                            
                            <span v-else-if="item.cover_profitPts" style="float: right">                               
                                {{ $t('PTS (total)') }}:&nbsp;
                                <span :class="{
                                'settled-won': item.cover_profitPts > 0,
                                'settled-void': item.cover_profitPts == 0,
                                'settled-lost': item.cover_profitPts < 0,
                            }">{{item.cover_profitPts}}</span></span>                               
                            
                            
                            <span v-else-if="item.profitPts !== '' && item.result" style="float: right">
                                Pts (total):&nbsp;<span
                                    :class="[`settled-${item.settled === 1 ? 'won':'lost'}`]">{{item.profitPts.toFixed(2)}}</span></span> -->
                            
                        </div>
                    </div>
                   
        
                    <div v-if="item.note" class="note-box">
                         <p class="note_letters">{{ $t('Note') }}:</p>
                        <div class="note">
                            {{item.note}}
                        </div>
                    </div>                    
                </div>
            </div>
        </div>
        <div class="action-box comments_button_box" :key="`${item.likeTip}${item.followTip}${item.isFollowed}`">
            <div v-if="trends_flag || !!item.settled" class="action comments_button selected" v-b-modal="item._id + 'trends'" @click="handleTrends(item.event)">
                stats
            </div>
            <div :class="{'action': true, 'selected': item.likeTip, 'comments_button': true}">
                {{(item.like || []).length}}
                <span :key="`like-${index}-${item.likeTip}`"
                    v-c-tooltip="!item.likeTip ? $t('Like this tip'):$t('You already liked this tip')"
                    @click="handleLikeTip(item._id)">
                    <CIcon name="cil-thumb-up" />
                </span>
                <!-- <span v-else>
                    <CIcon name="cil-thumb-up" class="disabled" />
                </span> -->
            </div>
            <div
                :class="{'action': true, 'selected': item.followTip || item.userId === parseInt(loggedInUser.user_id), 'comments_button': true}">
                {{(item.follow || []).length}}
                <span v-if="item.userId !== parseInt(loggedInUser.user_id)"
                    :key="`follow-${index}-${item.followTip}`"
                    v-c-tooltip="!item.followTip ? $t('Follow this tip'):$t('You already followed this tip')"
                    @click="handleFollowTip(item._id)">
                    <CIcon name="cil-star" />
                </span>
                <span v-else>
                    <CIcon name="cil-star" class="disabled" />
                </span>
            </div>
            <div :class="{'action': true, 'selected': item.isFollowed, 'comments_button': true}">
                {{item.followUserCount}}
                <span v-if="item.userId !== parseInt(loggedInUser.user_id)"
                    v-c-tooltip="!item.isFollowed ? $t('Follow this tipster'):$t('You already followed this tipster')"
                    @click="handleFollowUser(item._id)">
                    <CIcon name="cil-user-follow" />
                </span>
                <span v-else>
                    <CIcon name="cil-user-follow" class="disabled" />
                </span>
            </div>
            <div @click="revertOpencomments(index)" class="comments_btn">
                comments ( {{item.comments.length}} )
            </div>
        </div>
        <div v-if="item.openComments" class="comments">
            <p v-if="item.comments.length > limit" color="info" shape="pill" variant="outline" size="sm"
                class="ml-5 mb-3" @click="limit += 3" style="color: #5fa7fe;">
                read more comments
            </p>
            <div :key="`commnet-${cIndex}`" :id="'id' + comment._id" class="comment"
                v-for="(comment, cIndex) in item.comments.slice(-limit)">
                <div class="comment-header">
                    <avatar :size="30" :username="comment.userName" :src="comment.userAvatar"
                        :userId="comment.commentorId" />
                    &ensp;
                    <CLink :to="{name: 'UserTipStat', params: {id: comment.commentorId}}" style="color: blue;">
                        {{ comment.userName }}
                    </CLink> -
                    {{ comment.dateTime }}
                    &nbsp;
                    <span v-if="parseInt(loggedInUser.user_id) !== comment.commentorId"
                        @click="handleReply(item._id, comment.user[0])">
                        <CIcon name="cil-action-undo" class="rotate-90" />
                    </span>

                    <!-- <CButton v-if="parseInt(loggedInUser.user_id) === 0" color="danger" class="delete_comment" @click="handleDeleteComment(item._id, comment._id )">delete</CButton> -->
                    <button  v-if="parseInt(loggedInUser.user_id) === 0" type="button" aria-label="Close" class="close delete_comment" @click="handleDeleteComment(item._id, comment._id )"><span aria-hidden="true">×</span></button>
                </div>

                <p v-html="getComment(comment)" class="comment_area"></p>


                <span class="unread-mark" v-if="comment.unread"></span>
            </div>

        </div>
        <div v-if="item.openComments" class="post-comment">
            <CTextarea rows="2" :value.sync="comment" @input="comment=$event, editingIndex=index" :placeholder = "$t('write here your comment')" class="sub_post_comment" style="border-radius: 5px; border: 1px solid #ffc8d0;;"/>

            <CButton v-if="!comment" color="info" :disabled="!comment" @click="handlePostComment(item._id, comment), comment=''"
                style="background-color: #77b9fb; border: none">
                {{ $t('Post Comment') }}
            </CButton>
            <CButton v-else color="info" :disabled="!comment" @click="handlePostComment(item._id, comment), comment=''"
                style="background-color: #39F; border: none">
                {{ $t('Post Comment') }}
            </CButton>
        </div>

        <b-modal 
            :id="item._id" 
            @ok="handleOk"
            @cancel="handleCancel"
            @shown="modal_setFields"
        >
           <div style="display: flex">
                <div style="flex: 1">
                    <div>
                        <h5>{{ $t('Auto cash out (TIP)') }}</h5>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;  margin-right: 5px;">{{ $t('profit pts') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_profitPts" :value.sync="ref_profitPts" :disabled="tipCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left; margin-right: 5px;">{{ $t('profit %') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_profitPro" :value.sync="ref_profitPro" :disabled="tipCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;margin-right: 5px;">{{ $t('stop loss %') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_stoploss" :value.sync="ref_stoploss" :disabled="tipCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left; margin-right: 5px;">{{ $t('next odd (higher than)') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_nextodd" :value.sync="ref_nextodd" :disabled="tipCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left; margin-right: 5px;">{{ $t('next odd (lower than)') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_nextodd_lower" :value.sync="ref_nextodd_lower" :disabled="tipCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left; margin-right: 5px;">{{ $t('minute') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_time" :value.sync="ref_time" :disabled="tipCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <CSelect
                            :label="$t('score')"
                            placeholder="select..."
                            :options="predictionTypeOptions"
                            :value.sync="ref_score"
                            :disabled="tipCashout_disabled"
                        />
                    </div>
                    <div class="form-group ">
                        <label style="float: left;  margin-right: 5px;">{{ $t('attempt to accept (Max:10)') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.ref_numOfAttempt" :value.sync="ref_numOfAttempt" @update:value="set_ref_numOfAttempt" :disabled="tipCashout_disabled"></CInput>
                    </div>
                </div>
                <div style="flex: 1; padding-left: 10px">
                    <div>
                        <h5>{{ $t('Auto cash out (COVER)') }}</h5>
                    </div>
                    <div class="form-group ">
                        <label style="float: left; margin-right: 5px;">{{ $t('profit pts') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_profitPts" :value.sync="cover_ref_profitPts" :disabled="coverCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;  margin-right: 5px;">{{ $t('profit %') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_profitPro" :value.sync="cover_ref_profitPro" :disabled="coverCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;  margin-right: 5px;">{{ $t('stop loss %') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_stoploss" :value.sync="cover_ref_stoploss" :disabled="coverCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;margin-right: 5px;">{{ $t('next odd (higher than)') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_nextodd" :value.sync="cover_ref_nextodd" :disabled="coverCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;  margin-right: 5px;">{{ $t('next odd (lower than)') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_nextodd_lower" :value.sync="cover_ref_nextodd_lower" :disabled="coverCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        <label style="float: left;  margin-right: 5px;">{{ $t('minute') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_time" :value.sync="cover_ref_time" :disabled="coverCashout_disabled"></CInput>
                    </div>
                    <div class="form-group ">
                        
                        <CSelect
                            :label="$t('score')"
                            placeholder="select..."
                            :options="predictionTypeOptions"
                            :value.sync="cover_ref_score"
                            :disabled="coverCashout_disabled"                        
                        />
                        
                    </div>
                    <div class="form-group ">
                        <label style="float: left; margin-right: 5px;">{{ $t('attempt to accept (Max:10)') }}</label>
                        <CInput type="number" min="0" max="90000000" :value="item.cover_ref_numOfAttempt" :value.sync="cover_ref_numOfAttempt" @update:value="set_cover_ref_numOfAttempt" :disabled="coverCashout_disabled"></CInput>
                    </div>
                </div>
           </div>
           <template #modal-footer="{ ok, cancel, hide }">
                <b-button size="sm" variant="success" @click="ok()">
                    {{ $t('OK') }}
                </b-button>
                <b-button size="sm" variant="danger" @click="cancel()">
                    {{ $t('Cancel') }}
                </b-button>              
                <b-button size="sm" variant="outline-secondary" @click="cleanModal()">
                    {{ $t('Clean') }}
                </b-button>
            </template>
        </b-modal>

        <b-modal :id="item._id + 'trends'" class="live-stats-modal" centered :title="historicModalData.eventName">
                <div v-if="!isload" style="height: 10px;">
                    <b-progress :value="current_counter" :max="counter" animated></b-progress>
                </div>
                <div v-else>

                    <CTabs variant="tabs" :active-tab="0">
                        <CTab :title="$t('Stats')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content detail_total" style="width: 100%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        Stats
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                Goals
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                On
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                Off
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                Cnr
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                Dak
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                Pos
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                Red
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                Yel
                                            </div> 
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                Sbst
                                            </div>  
                                            
                                        </div>
                                    </div>
                                    
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div :id="h_goalsKey" class="detail season-detail" style="min-width: 20px!important;"  v-b-tooltip.hover :title = "h_goals_tooltip">
                                                {{h_goals}}
                                            </div>
                                            
                                            <div :id="h_onKey" class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "h_on_tooltip">
                                                {{h_on}}
                                            </div>
                                            <div :id="h_offKey" class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "h_off_tooltip" >
                                                {{h_off}}
                                            </div>
                                            <div :id="h_cnrKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "h_cnr_tooltip">
                                                {{h_cnr}}
                                            </div>
                                            <div :id="h_dakKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "h_dak_tooltip">
                                                {{h_dak}}
                                            </div>
                                            <div :id="h_posKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "h_pos_tooltip">
                                                {{h_pos}}
                                            </div>
                                            <div :id="h_redKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "h_red_tooltip">
                                                {{h_red}}
                                            </div>
                                            <div :id="h_yelKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "h_yel_tooltip">
                                                {{h_yel}}
                                            </div>
                                            <div :id="h_sbstKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "h_sbst_tooltip">
                                                {{h_sbst}}
                                            </div>

                                            <!-- <b-tooltip :target="h_goalsKey" v-if="h_goals_tooltip" triggers="hover">
                                                {{h_goals_tooltip}}
                                            </b-tooltip> -->
                                            <!-- <b-tooltip :target="h_onKey" v-if="h_on_tooltip" triggers="hover">
                                                {{h_on_tooltip}}
                                            </b-tooltip> -->
                                           <!--  <b-tooltip :target="h_offKey" v-if="h_off_tooltip" triggers="hover">
                                                {{h_off_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="h_cnrKey" v-if="h_cnr_tooltip" triggers="hover">
                                                {{h_cnr_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="h_dakKey" v-if="h_dak_tooltip" triggers="hover">
                                                {{h_dak_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="h_posKey" v-if="h_pos_tooltip" triggers="hover">
                                                {{h_pos_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="h_redKey" v-if="h_red_tooltip" triggers="hover">
                                                {{h_red_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="h_yelKey" v-if="h_yel_tooltip" triggers="hover">
                                                {{h_yel_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="h_sbstKey" v-if="h_sbst_tooltip" triggers="hover">
                                                {{h_sbst_tooltip}}
                                            </b-tooltip> -->
                                        </div>
                                        
                                    </div>                                   

                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div :id="a_goalsKey" class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "a_goals_tooltip">
                                                {{a_goals}}
                                            </div>
                                            <div :id="a_onKey" class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "a_on_tooltip">
                                                {{a_on}}
                                            </div>
                                            <div :id="a_offKey" class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "a_off_tooltip">
                                                {{a_off}}
                                            </div>
                                            <div :id="a_cnrKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "a_cnr_tooltip">
                                                {{a_cnr}}
                                            </div>
                                            <div :id="a_dakKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "a_dak_tooltip">
                                                {{a_dak}}
                                            </div>
                                            <div :id="a_posKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "a_pos_tooltip">
                                                {{a_pos}}
                                            </div>
                                            <div :id="a_redKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "a_red_tooltip">
                                                {{a_red}}
                                            </div>
                                            <div :id="a_yelKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "a_yel_tooltip">
                                                {{a_yel}}
                                            </div>
                                            <div :id="a_sbstKey" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important" v-b-tooltip.hover :title = "a_sbst_tooltip">
                                                {{a_sbst}}
                                            </div>

                                           <!--  <b-tooltip :target="a_goalsKey" v-if="a_goals_tooltip" triggers="hover">
                                                {{a_goals_tooltip}}
                                            </b-tooltip> -->
                                            <!-- <b-tooltip :target="a_onKey" v-if="a_on_tooltip" triggers="hover">
                                                {{a_on_tooltip}}
                                            </b-tooltip> -->
                                           <!--  <b-tooltip :target="a_offKey" v-if="a_off_tooltip" triggers="hover">
                                                {{a_off_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="a_cnrKey" v-if="a_cnr_tooltip" triggers="hover">
                                                {{a_cnr_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="a_dakKey" v-if="a_dak_tooltip" triggers="hover">
                                                {{a_dak_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="a_posKey" v-if="a_pos_tooltip" triggers="hover">
                                                {{a_pos_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="a_redKey" v-if="a_red_tooltip" triggers="hover">
                                                {{a_red_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="a_yelKey" v-if="a_yel_tooltip" triggers="hover">
                                                {{a_yel_tooltip}}
                                            </b-tooltip>
                                            <b-tooltip :target="a_sbstKey" v-if="a_sbst_tooltip" triggers="hover">
                                                {{a_sbst_tooltip}}
                                            </b-tooltip>
                                             -->
                                            
                                        </div>
                                        
                                    </div>

                                    
                                </div>
                                
                            </div>
                        </CTab>
                        <CTab :title="$t('Historical Stats')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content" style="text-align: center; padding-top: 20px; width: 5%; height: 50px; float: left; background: #8db4e2; border-left: 1px solid #ffffff;">
                                        P
                                    </div>
                                    <div class="header-content detail_total" style="width: 95%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        {{ $t('Avg Stats Per Game') }}
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 30px!important; width: 6.5%!important">
                                                {{ $t('Goals') }}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 4.5%!important">
                                                On
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                Off
                                            </div>
                                            <div class="detail season-detail">
                                                Blk
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 5%!important">
                                                In
                                            </div>
                                            <div class="detail season-detail">
                                                Out
                                            </div>
                                            <div class="detail season-detail">
                                                Cnr
                                            </div>
                                            <div class="detail season-detail">
                                                DA
                                            </div>
                                            <div class="detail season-detail" style="min-width: 30px;">
                                                Pos
                                            </div>
                                            <div class="detail season-detail">
                                                Pas
                                            </div>
                                            <div class="detail season-detail">
                                                Acc
                                            </div>
                                            <div class="detail season-detail">
                                                Atk
                                            </div>
                                            <div class="detail season-detail">
                                                Ofs
                                            </div>
                                            <div class="detail season-detail">
                                                Sav
                                            </div>
                                            <div class="detail season-detail">
                                                Sbst
                                            </div>
                                            <div class="detail season-detail">
                                                Fou
                                            </div>
                                            <div class="detail season-detail" style="min-width: 30px!important; width: 6%!important">
                                                G_att
                                            </div>
                                            <div class="detail season-detail">
                                                Safe
                                            </div>
                                            <div class="detail season-detail">
                                                Rtg
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 5%; height: 30px; float: left; border-left: 1px solid #e2e2e2; border-bottom: 1px solid #e2e2e2;">
                                        <div style="text-align: center;">{{historicModalData.home_p}}</div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 95%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="historicModalData.home_season.goals == 0" class="detail season-detail"  style="color: red; min-width: 45px!important;">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.goals == null" class="detail season-detail" style="min-width: 45px!important;">
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.goals != 0 && historicModalData.home_season.goals != null" class="detail season-detail" style="color: green; min-width: 45px!important;">
                                                {{(historicModalData.home_season.goals/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.on == 0" class="detail season-detail" style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.on == null" class="detail season-detail" style="color: red">
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.on != null && historicModalData.home_season.on != 0" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.on/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.off == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.off == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.off != 0 && historicModalData.home_season.off != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.off/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.blk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.blk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.blk != 0 && historicModalData.home_season.blk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.blk/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.in == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.in == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.in != 0 && historicModalData.home_season.in != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.in/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.out == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.out == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.out != 0 && historicModalData.home_season.out != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.out/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr != 0 && historicModalData.home_season.cnr != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.cnr/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.da == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.da == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.da != 0 && historicModalData.home_season.da != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.da/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.pos == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.pos == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.pos != 0 && historicModalData.home_season.pos != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.pos/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.pas == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.pas == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.pas != 0 && historicModalData.home_season.pas != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.pas/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.acc == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.acc == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.acc != 0 && historicModalData.home_season.acc != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.acc/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.atk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.atk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.atk != 0 && historicModalData.home_season.atk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.atk/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs != 0 && historicModalData.home_season.ofs != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.ofs/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.sav == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.sav == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.sav != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.sav/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.sbst/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.fou == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.fou == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.fou != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.fou/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att != 0 && historicModalData.home_season.g_att != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.g_att/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.safe == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.safe == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.safe != 0 && historicModalData.home_season.safe != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.safe/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div class="detail season-detail" style="color: #263043; font-weight: bold;">
                                                {{(historicModalData.home_a_rtg).toFixed(0)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 5%; height: 30px; float: left; border-left: 1px solid #e2e2e2; border-bottom: 1px solid #e2e2e2;">
                                        <div style="text-align: center;">{{historicModalData.away_p}}</div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 95%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="historicModalData.away_season.goals == 0" class="detail season-detail"  style="color: red; min-width: 45px!important;">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.goals == null" class="detail season-detail" style="min-width: 45px!important;">
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.goals != 0 && historicModalData.away_season.goals != null" class="detail season-detail" style="color: green; min-width: 45px!important;">
                                                {{(historicModalData.away_season.goals/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.on == 0" class="detail season-detail" style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.on == null" class="detail season-detail" style="color: red">
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.on != null && historicModalData.away_season.on != 0" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.on/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.off == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.off == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.off != 0 && historicModalData.away_season.off != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.off/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.blk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.blk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.blk != 0 && historicModalData.away_season.blk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.blk/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.in == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.in == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.in != 0 && historicModalData.away_season.in != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.in/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.out == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.out == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.out != 0 && historicModalData.away_season.out != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.out/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr != 0 && historicModalData.away_season.cnr != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.cnr/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.da == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.da == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.da != 0 && historicModalData.away_season.da != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.da/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.pos == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.pos == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.pos != 0 && historicModalData.away_season.pos != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.pos/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.pas == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.pas == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.pas != 0 && historicModalData.away_season.pas != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.pas/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.acc == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.acc == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.acc != 0 && historicModalData.away_season.acc != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.acc/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.atk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.atk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.atk != 0 && historicModalData.away_season.atk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.atk/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs != 0 && historicModalData.away_season.ofs != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.ofs/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.sav == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.sav == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.sav != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.sav/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.sbst/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.fou == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.fou == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.fou != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.fou/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att != 0 && historicModalData.away_season.g_att != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.g_att/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.safe == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.safe == null" class="detail season-detail" >
                                                -
                                            </div>
                                            <div  v-if="historicModalData.away_season.safe != 0 && historicModalData.away_season.safe != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.safe/historicModalData.away_p).toFixed(1)}}
                                            </div>
                                            <div class="detail season-detail" style="color: #263043; font-weight: bold;">
                                                {{(historicModalData.away_a_rtg).toFixed(0)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CTab>
                        <!-- <CTab :title="$t('Chart')">
                            <div class="modal-tab-content" style="height: auto">
                                <div style="min-width: 714px;">
                                    <Plotly :data="data" :layout="layout" :display-mode-bar="true"></Plotly>
                                </div>
                            </div>
                        </CTab> -->
                        <CTab :title="$t('Odds')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content detail_total" style="width: 100%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        Odds
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                H
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                D
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                A
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-0.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-0.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-1.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-1.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-2.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-2.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-3.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-3.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                O-0.5(ht)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                U-0.5(ht)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                BTS(yes)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                BTS(no)
                                            </div>
                                            
                                        </div>
                                    </div>
                                    
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                {{this.flatodds.h_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                            {{this.flatodds.d_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                            {{this.flatodds.a_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_05}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                            {{this.flatodds.u_05}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_15}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_15}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_25}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_25}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_35}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_35}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                            {{this.flatodds.o_05_ht}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                {{this.flatodds.u_05_ht}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                {{this.flatodds.bts_yes}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                {{this.flatodds.bts_no}}
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div  v-if="flatodds.prob_home != '-'" class="detail season-detail" style="min-width: 20px!important;">
                                                <span id="prob_home" :class="{'green-label' : flatodds.prob_home_tt2 > 10 }">{{flatodds.prob_home + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_draw != '-'" class="detail season-detail" style="min-width: 20px!important;">
                                                <span id="prob_draw" :class="{'green-label' : flatodds.prob_draw_tt2 > 10 }">{{this.flatodds.prob_draw + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_away != '-'" class="detail season-detail" style="min-width: 20px!important;" >
                                                <span id="prob_away" :class="{'green-label' : flatodds.prob_away_tt2 > 10 }">{{this.flatodds.prob_away + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over05 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over05" :class="{'green-label' : flatodds.prob_over05_tt2 > 10 }">{{this.flatodds.prob_over05 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under05 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under05"  :class="{'green-label' : flatodds.prob_under05_tt2 > 10 }">{{this.flatodds.prob_under05 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over15 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over15" :class="{'green-label' : flatodds.prob_over15_tt2 > 10 }">{{this.flatodds.prob_over15 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under15 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under15" :class="{'green-label' : flatodds.prob_under15_tt2 > 10 }">{{this.flatodds.prob_under15 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over25 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over25" :class="{'green-label' : flatodds.prob_over25_tt2 > 10 }">{{this.flatodds.prob_over25 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under25 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under25" :class="{'green-label' : flatodds.prob_under25_tt2 > 10 }">{{this.flatodds.prob_under25 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over35 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over35" :class="{'green-label' : flatodds.prob_over35_tt2 > 10 }">{{this.flatodds.prob_over35 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under35 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under35" :class="{'green-label' : flatodds.prob_under35_tt2 > 10 }">{{this.flatodds.prob_under35 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over05_ht != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                <span id="prob_over05_ht" :class="{'green-label' : flatodds.prob_over05_ht_tt2 > 10 }">{{this.flatodds.prob_over05_ht + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under05_ht != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                <span id="prob_under05_ht" :class="{'green-label' : flatodds.prob_under05_ht_tt2 > 10 }">{{this.flatodds.prob_under05_ht + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_bts != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                <span id="prob_bts" :class="{'green-label' : flatodds.prob_bts_tt2 > 10 }">{{this.flatodds.prob_bts + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_bts_no != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                <span id="prob_bts_no" :class="{'green-label' : flatodds.prob_bts_no_tt2 > 10 }">{{this.flatodds.prob_bts_no + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                -
                                            </div>
                                            
                                        </div>
                                        
                                        <b-tooltip v-if="flatodds.prob_home_tt2" target="prob_home" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_home_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_home_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_away_tt2" target="prob_away" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_away_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_away_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_draw_tt2" target="prob_draw" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_draw_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_draw_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over05_tt2" target="prob_over05" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over05_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over15_tt2" target="prob_over15" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over15_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over25_tt2" target="prob_over25" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over25_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over35_tt2" target="prob_over35" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over35_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under05_tt2" target="prob_under05" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under05_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under15_tt2" target="prob_under15" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under15_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under25_tt2" target="prob_under25" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under25_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under35_tt2" target="prob_under35" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under35_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over05_ht_tt2" target="prob_over05_ht" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over05_ht_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under05_ht_tt2" target="prob_under05_ht" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under05_ht_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_bts_tt2" target="prob_bts" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_bts_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_bts_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_bts_no_tt2" target="prob_bts_no" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_bts_no_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_bts_no_tt2}}%</span>
                                        </b-tooltip>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none; padding-left: 15px;">
                                        {{matches_sample}} matches sample
                                    </div>
                                </div>
                                
                            </div>
                        </CTab>
                        
                    </CTabs>
                </div>
            </b-modal>
    </div>

    

</template>

<script>
    import {mapActions, mapGetters } from 'vuex';

    import Avatar from '@/components/Avatar';
    import { capitalizeFL } from '@/helpers/string';

    export default {
        components: {
            Avatar,
        },
        props: {
            index: {
                type: Number,
                required: true,
            },
            loading: {
                type: Boolean,
                default: false
            },
            cover_loading: {
                type: Boolean,
                default: false
            },
            item: {
                type: Object,
                required: true,
            },
            unread: {
                type: Boolean,
                default: false
            },
            handleLikeTip: {
                type: Function,
                requried: true,
            },
            handleFollowTip: {
                type: Function,
                required: true
            },
            handleFollowUser: {
                type: Function,
                required: true
            },
            handlePostComment: {
                type: Function,
                required: true
            },
            handleSelectReply: {
                type: Function,
                required: true
            },
            handleFollowStrategy: {
                type: Function,
            },
            onCashOut: {
                type: Function
            },
            handleDeleteTip: {
                type: Function
            },
            handleDeleteComment: {
                type: Function
            },
            trends_flag: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapGetters(['loggedInUser']),
            isMe() {
                return this.loggedInUser && this.item.userId === parseInt(this.loggedInUser.user_id);
            },
            predictionTypeOptions() {
                var options = ['Home', 'Draw', 'Away'];
                var currentScore = this.item.currentScore;
                if (currentScore == '') {
                    return []
                }
                var homeScore = parseInt(currentScore.split(':')[0].trim());
                var awayScore = parseInt(currentScore.split(':')[1].trim());
                var totalScore = homeScore + awayScore;
                if (homeScore === 0 || awayScore === 0)
                    options.push('BTS');
                if (totalScore < 1)
                    options.push('Over 0.5');
                if (totalScore < 2)
                    options.push('Over 1.5');
                if (totalScore < 3)
                    options.push('Over 2.5');
                if (totalScore < 4)
                    options.push('Over 3.5');
                if (totalScore < 5)
                    options.push('Over 4.5');
                options.push('None');
                return options;
            },
            tipCashout_disabled() {
                if (this.item.cashout || !this.item.currentOdd || this.item.currentOdd_suspended || this.item.currentPointProfit === '')
                    return true;
                else
                    return false;
            },
            coverCashout_disabled() {
                if (this.item.cover_cashout || !this.item.cover_currentOdd || this.item.cover_currentOdd_suspended || this.item.cover_currentPointProfit === '' ||  !this.item.cover_cashOut_flag)
                    return true;
                else
                    return false;
            }
            
        },
        data() {
            return {
                comment: '',
                limit: 3,
                currentStatus: '',
                currentPointProfit: '',
                currentScore: '',
                cashOut: '',
                currentOdd: '',
                cashout_setting: true,
                ref_profitPts: this.item.ref_profitPts,

                ref_profitPro: this.item.ref_profitPro,
                ref_stoploss: this.item.ref_stoploss,
                ref_nextodd: this.item.ref_nextodd,
                ref_nextodd_lower: this.item.ref_nextodd_lower,
                ref_time: this.item.ref_time,
                ref_score: this.item.ref_score,
                ref_numOfAttempt: this.item.ref_numOfAttempt,
                cover_ref_profitPts: this.item.cover_ref_profitPts,
                cover_ref_profitPro: this.item.cover_ref_profitPro,
                cover_ref_stoploss: this.item.cover_ref_stoploss,
                cover_ref_nextodd: this.item.cover_ref_nextodd,
                cover_ref_nextodd_lower: this.item.cover_ref_nextodd_lower,
                cover_ref_time: this.item.cover_ref_time,
                cover_ref_score: this.item.cover_ref_score,
                cover_ref_numOfAttempt: this.item.cover_ref_numOfAttempt,
                historicModalData:{
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 1,
                    "away_p": 1,
                    "home_rtg": 0,
                    "home_a_rtg": 0,
                    "away_rtg": 0,
                    "away_a_rtg": 0
                },
                flatodds: {
                    "h_win": "-",
                    "a_win": "-",
                    "d_win": "-",
                    "o_05": "-",
                    "o_15": "-",
                    "o_25": "-",
                    "o_35": "-",
                    "u_05": "-",
                    "u_15": "-",
                    "u_25": "-",
                    "u_35": "-",
                    "o_05_ht": "-",
                    "u_05_ht": "-",
                    "bts_yes": "-",
                    "bts_no": "-",
                    prob_home: "-",
                    prob_draw: "-",
                    prob_away : "-",
                    prob_over05: "-",
                    prob_over15: "-",
                    prob_over25 : "-",
                    prob_over35 : "-",
                    prob_bts: "-",
                    prob_over05_ht: "-",

                    prob_under05: "-",
                    prob_under15: "-",
                    prob_under25 : "-",
                    prob_under35: "-",

                    prob_bts_no: "-",
                    prob_under05_ht: "-",

                    prob_home_tt1: null,
                    prob_home_tt2: null,
                    prob_away_tt1: null,
                    prob_away_tt2: null,
                    prob_draw_tt1: null,
                    prob_draw_tt2: null,
                    prob_over05_tt1: null,
                    prob_over05_tt2: null,
                    prob_over15_tt1: null,
                    prob_over15_tt2: null,
                    prob_over25_tt1: null,
                    prob_over25_tt2: null,
                    prob_over35_tt1: null,
                    prob_over35_tt2: null,
                    prob_under05_tt1: null,
                    prob_under05_tt2: null,
                    prob_under15_tt1: null,
                    prob_under15_tt2: null,
                    prob_under25_tt1: null,
                    prob_under25_tt2: null,
                    prob_under35_tt1: null,
                    prob_under35_tt2: null,
                    prob_over05_ht_tt1: null,
                    prob_over05_ht_tt2: null,
                    prob_under05_ht_tt1: null,
                    prob_under05_ht_tt2: null,
                    prob_bts_tt1: null,
                    prob_bts_tt2: null,
                    prob_bts_no_tt1: null,
                    prob_bts_no_tt2: null,

                },
                matches_sample: 0,
                isload: false,
                counter: 50,
                current_counter: 0,

                h_on_tooltip: '',
                h_on: '',
                h_off_tooltip: '',
                h_off: '',
                h_cnr_tooltip: '',
                h_cnr: '',
                h_dak_tooltip: '',
                h_dak: '',
                h_pos_tooltip: '',
                h_pos: '',
                h_red_tooltip: '',
                h_red: '',
                h_yel_tooltip: '',
                h_yel: '',
                h_goals_tooltip: '',
                h_goals: '',

                h_sbst_tooltip: '',
                h_sbst: '',

                a_on_tooltip: '',
                a_on: '',
                a_off_tooltip: '',
                a_off: '',
                a_cnr_tooltip: '',
                a_cnr: '',
                a_dak_tooltip: '',
                a_dak: '',
                a_pos_tooltip: '',
                a_pos: '',
                a_red_tooltip: '',
                a_red: '',
                a_yel_tooltip: '',
                a_yel: '',
                a_goals_tooltip: '',
                a_goals: '',
                a_sbst_tooltip: '',
                a_sbst: '',
            };
        },
        methods: {
            get_trueodds_value(odds, stat) {
                var true_odd = 100 / stat;
                var value = ( (odds - 1) * 100 / (true_odd - 1) ) - 100
                return [true_odd, value]
            },
            create_UUID(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid
            },
            set_ref_numOfAttempt(val) {
                if (val > 10)
                    this.ref_numOfAttempt = 10;
            },
            set_cover_ref_numOfAttempt(val) {
                if (val > 10)
                    this.cover_ref_numOfAttempt = 10;
            },
            ...mapActions([
                'postCashoutRef'                
            ]),
            modal_setFields() {
                this.ref_profitPts = this.item.ref_profitPts
                this.ref_profitPro = this.item.ref_profitPro
                this.ref_stoploss = this.item.ref_stoploss
                this.ref_nextodd = this.item.ref_nextodd
                this.ref_nextodd_lower = this.item.ref_nextodd_lower
                this.ref_time = this.item.ref_time
                this.ref_score = this.item.ref_score
                if (!this.item.ref_numOfAttempt)
                    this.ref_numOfAttempt = 1
                else
                    this.ref_numOfAttempt = this.item.ref_numOfAttempt
                this.cover_ref_profitPts = this.item.cover_ref_profitPts
                this.cover_ref_profitPro = this.item.cover_ref_profitPro
                this.cover_ref_stoploss = this.item.cover_ref_stoploss
                this.cover_ref_nextodd = this.item.cover_ref_nextodd
                this.cover_ref_nextodd_lower = this.item.cover_ref_nextodd_lower
                this.cover_ref_time = this.item.cover_ref_time
                this.cover_ref_score = this.item.cover_ref_score
                if (!this.item.cover_ref_numOfAttempt)
                    this.cover_ref_numOfAttempt = 1
                else
                    this.cover_ref_numOfAttempt = this.item.cover_ref_numOfAttempt

            },
            cleanModal(bvModalEvt) {
                console.log('clean modal');
                
                this.ref_profitPts = ''
                this.ref_profitPro = ''
                this.ref_stoploss = ''
                this.ref_nextodd = ''
                this.ref_nextodd_lower = ''
                this.ref_time = ''
                this.ref_score = ''
                this.ref_numOfAttempt = '1'
                this.cover_ref_profitPts = ''
                this.cover_ref_profitPro = ''
                this.cover_ref_stoploss = ''
                this.cover_ref_nextodd = ''
                this.cover_ref_nextodd_lower = ''
                this.cover_ref_time = ''
                this.cover_ref_score = ''
                this.cover_ref_numOfAttempt = '1'
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                this.handleSubmit()
            },
            handleCancel(bvModalEvt) {
                console.log('cancle button')
                bvModalEvt.preventDefault()
                this.ref_profitPts = this.item.ref_profitPts
                this.ref_profitPro = this.item.ref_profitPro
                this.ref_stoploss = this.item.ref_stoploss
                this.ref_nextodd = this.item.ref_nextodd
                this.ref_nextodd_lower = this.item.ref_nextodd_lower
                this.ref_time = this.item.ref_time
                this.ref_score = this.item.ref_score
                if (!this.item.ref_numOfAttempt)
                    this.ref_numOfAttempt = 1
                else
                    this.ref_numOfAttempt = this.item.ref_numOfAttempt
                this.cover_ref_profitPts = this.item.cover_ref_profitPts
                this.cover_ref_profitPro = this.item.cover_ref_profitPro
                this.cover_ref_stoploss = this.item.cover_ref_stoploss
                this.cover_ref_nextodd = this.item.cover_ref_nextodd
                this.cover_ref_nextodd_lower = this.item.cover_ref_nextodd_lower
                this.cover_ref_time = this.item.cover_ref_time
                this.cover_ref_score = this.item.cover_ref_score
                if (!this.item.cover_ref_numOfAttempt)
                    this.cover_ref_numOfAttempt = 1
                else
                    this.cover_ref_numOfAttempt = this.item.cover_ref_numOfAttempt
                this.$nextTick(() => {
                    this.$bvModal.hide(this.item._id)
                })
                
            },
            handleSubmit() {
                var cashout_ref = {
                    'ref_profitPts': this.ref_profitPts,
                    'ref_profitPro': this.ref_profitPro,
                    'ref_stoploss': this.ref_stoploss,
                    'ref_nextodd': this.ref_nextodd,
                    'ref_time': this.ref_time,
                    'ref_score': this.ref_score,
                    'ref_numOfAttempt': this.ref_numOfAttempt,
                    'ref_momnent_score': this.item.currentScore
                }

                var cover_cashout_ref = {
                    'cover_ref_profitPts': this.cover_ref_profitPts,
                    'cover_ref_profitPro': this.cover_ref_profitPro,
                    'cover_ref_stoploss': this.cover_ref_stoploss,
                    'cover_ref_nextodd': this.cover_ref_nextodd,
                    'cover_ref_time': this.cover_ref_time,
                    'cover_ref_score': this.cover_ref_score,
                    'cover_ref_numOfAttempt': this.cover_ref_numOfAttempt
                }

                this.postCashoutRef({_id: this.item._id, cashout_ref: cashout_ref, cover_cashout_ref: cover_cashout_ref}).then((data) => {
                    this.item.ref_profitPts = this.ref_profitPts;
                    this.item.ref_profitPro = this.ref_profitPro;
                    this.item.ref_stoploss = this.ref_stoploss;
                    this.item.ref_nextodd = this.ref_nextodd;
                    this.item.ref_time = this.ref_time;
                    this.item.ref_score = this.ref_score;
                    this.item.ref_numOfAttempt = this.ref_numOfAttempt;

                    this.item.cover_ref_profitPts = this.cover_ref_profitPts;
                    this.item.cover_ref_profitPro = this.cover_ref_profitPro;
                    this.item.cover_ref_stoploss = this.cover_ref_stoploss;
                    this.item.cover_ref_nextodd = this.cover_ref_nextodd;
                    this.item.cover_ref_time = this.cover_ref_time;
                    this.item.cover_ref_score = this.cover_ref_score;
                    this.item.cover_ref_numOfAttempt = this.cover_ref_numOfAttempt;
                    
                }).finally(() => {
                    console.log('final')
                });
                
                // Hide the modal manually
                this.$nextTick(() => {
                    this.$bvModal.hide(this.item._id)
                })
            },
            revertOpencomments(index) {
                console.log('click comments')
                this.item.openComments = !this.item.openComments;
            },
            getComment(comment) {
                let result = comment.comment;
                if (comment.replyToIds && comment.replyToIds.length > 0) {
                    comment.replyToUsers.forEach(cItem => {
                        result = result.replace(`@${cItem.alias},`, `<a href="#/user_tip_stat/${cItem._id}"><strong>@${cItem.alias}</strong></a>`);
                    });
                }
                return result;
            },
            capitalizeVisibility(str) {
                return capitalizeFL(str);
            },
            handleReply(idx, user) {
                this.comment = `@${user.alias}, ` + this.comment;
                this.handleSelectReply(idx, user);
            },
            calcCashOut() {
                if (this.item.cashout) {
                    const scores = this.item.fixture[0].scores;
                    if (scores.ft_score && scores.ht_score)
                        this.currentStatus = `${scores.ft_score} FT(${scores.ht_score} HT)`;
                    else if (scores.ht_score)
                        this.currentStatus = `${scores.ht_score} HT`;
                    else
                        this.currentStatus = 'NS';
                } else if (this.item.settled === 0) {
                    const fixture = this.item.fixture;
                    const status = fixture[0].time.status;
                    const time = fixture[0].time;
                    const scores = fixture[0].scores;
                    /** get current status */
                    this.currentStatus = status;
                    if (status === 'LIVE' || status === 'HT') {
                        let minute = time.minute ? `${Math.floor(time.minute / 10)}${time.minute % 10}'` : '00\'';
                        let second = time.second ? time.second : '00';
                        let added_time = time.added_time ? `+${time.added_time}\'` : '';
                        this.currentStatus = `${time.status}  ${minute} ${second} ${added_time}`;
                    }
                    /** current score */
                    this.currentScore = `${scores.localteam_score} : ${scores.visitorteam_score}`;
                    /** get current odd */
                    let odds = [], currentOdd = '';
                    const ft_market_ids = [1, 12, 976105, 136703813, 137918022, 28077, 1256989864];
                    const ht_market_ids = [37, 31379, 975903, 976226, 31359];

                    if (status === 'LIVE' || status == 'HT') {
                        odds = fixture[0].inplayOdds.data;
                    } else if (status === 'NS') {
                        odds = fixture[0].flatOdds.data;
                    }
                    odds
                        .filter(item => item.bookmaker_id === 2)
                        .forEach(oItem => {
                            let suffix = '';
                            if (ft_market_ids.includes(oItem.market_id))
                                suffix = 'FT';
                            else if (ht_market_ids.includes(oItem.market_id))
                                suffix = 'HT';
                            (oItem.odds || oItem.values).forEach(item => {
                                let label;
                                if (item.label)
                                    label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                else if (item.team)
                                    label = item.team;
                                else if (item.info) {
                                    label = item.info;
                                }
                                if (label === 'Yes')
                                    label = 'BTS';
                                else if (label === 'No')
                                    label = 'No BTS';
                                if (label === '1')
                                    label = "Home";
                                else if (label === '2')
                                    label = 'Away';
                                else if (label === 'X')
                                    label = 'Draw';

                                if (`${label} - ${suffix}`.trim() === this.item.predictionType)
                                    currentOdd = parseFloat(item.value);

                            });
                        });
                    if (currentOdd) {
                        this.currentOdd = currentOdd;
                        /** cash out */
                        this.cashOut = parseFloat((this.item.odd * this.item.stake / currentOdd).toFixed(2));
                        /** current point profit */
                        this.currentPointProfit = parseFloat((this.cashOut - this.item.stake).toFixed(2));
                    }
                }
            },
            set_ref_profitPts(val) {
                this.ref_profitPts = val;
            },
            frame() {
                if (this.current_counter >= 45) {
                    this.current_counter = 45
                    clearInterval(this.clock);
                } else {
                    this.current_counter++;                    
                }
            },
            percallfunction(){
                this.current_counter = 0
                clearInterval(this.clock)               
            },
            handleTrends(fixtureId) {
                this.historicModalData = {
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 0,
                    "away_p": 0,
                    "home_rtg": 0,
                    "home_a_rtg": 0,
                    "away_rtg": 0,
                    "away_a_rtg": 0
                }
                this.isload = false;
                this.current_counter = 0
                console.log(this.current_counter)
                clearInterval(this.clock)
                this.clock = setInterval(this.frame, 100)

                window.axios.post(`${process.env.VUE_APP_URL}getLiveEventHistory`, [fixtureId]).then(({data})=> {

                    
                    let seasonData = data.data[0][0]
                    this.historicModalData.eventName = seasonData.localTeamName + ' v ' + seasonData.visitorTeamName;
                    console.log(this.historicModalData.eventName)
                    let home_poss_index = 0
                    let away_poss_index = 0
                    let home_p = 0
                    let away_p = 0
                    let home_season = {}
                    let away_season = {}
                    if(seasonData.home_season){
                        home_p = seasonData.home_season.p
                        away_p = seasonData.away_season.p
                        home_season = seasonData.home_season
                        away_season = seasonData.away_season
                    }

                    this.flatodds = {
                        "h_win": "-",
                        "a_win": "-",
                        "d_win": "-",
                        "o_05": "-",
                        "o_15": "-",
                        "o_25": "-",
                        "o_35": "-",
                        "u_05": "-",
                        "u_15": "-",
                        "u_25": "-",
                        "u_35": "-",
                        "o_05_ht": "-",
                        "u_05_ht": "-",
                        "bts_yes": "-",
                        "bts_no": "-",
                        prob_home: "-",
                        prob_draw: "-",
                        prob_away : "-",
                        prob_over05: "-",
                        prob_over15: "-",
                        prob_over25 : "-",
                        prob_over35 : "-",
                        prob_bts: "-",
                        prob_over05_ht: "-",

                        prob_under05: "-",
                        prob_under15: "-",
                        prob_under25 : "-",
                        prob_under35: "-",

                        prob_bts_no: "-",
                        prob_under05_ht: "-",

                        prob_home_tt1: null,
                        prob_home_tt2: null,
                        prob_away_tt1: null,
                        prob_away_tt2: null,
                        prob_draw_tt1: null,
                        prob_draw_tt2: null,
                        prob_over05_tt1: null,
                        prob_over05_tt2: null,
                        prob_over15_tt1: null,
                        prob_over15_tt2: null,
                        prob_over25_tt1: null,
                        prob_over25_tt2: null,
                        prob_over35_tt1: null,
                        prob_over35_tt2: null,
                        prob_under05_tt1: null,
                        prob_under05_tt2: null,
                        prob_under15_tt1: null,
                        prob_under15_tt2: null,
                        prob_under25_tt1: null,
                        prob_under25_tt2: null,
                        prob_under35_tt1: null,
                        prob_under35_tt2: null,
                        prob_over05_ht_tt1: null,
                        prob_over05_ht_tt2: null,
                        prob_under05_ht_tt1: null,
                        prob_under05_ht_tt2: null,
                        prob_bts_tt1: null,
                        prob_bts_tt2: null,
                        prob_bts_no_tt1: null,
                        prob_bts_no_tt2: null,

                    };
                    this.matches_sample = 0;

                    if (seasonData.DailyFixtures.length != 0) {
                        
                        
                        if (seasonData.DailyFixtures[0].leagueStats) {
                            
                            this.flatodds = seasonData.DailyFixtures[0].leagueStats;
                            this.matches_sample = seasonData.DailyFixtures[0].leagueStats.matches_sample;
                        }
                        else {
                            seasonData.DailyFixtures[0].flatOdds.data.forEach((oItem) => {
                                let mkt_id = oItem.market_id;
                                if(oItem.bookmaker_id === 2) {
                                    let suffix;
                                    if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                        suffix = 'FT';
                                    else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226 || mkt_id === 31359)
                                        suffix = 'HT';
                                    (oItem.odds || oItem.values).forEach((item) => {
                                        let label;
                                        if(item.label)
                                            label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                        else if(item.team)
                                            label = item.team;
                                        else if(item.info) {
                                            label = item.info;
                                        }
                                        if(label === 'Yes')
                                            label = 'BTS';
                                        else if(label === 'No')
                                            label = 'No BTS';
                                        if(label === '1')
                                            label = "Home";
                                        else if(label === '2')
                                            label = 'Away';
                                        else if(label === 'X')
                                            label = 'Draw';
                                        if(!label.includes(",")) {              //except over 2.0,2.5 case
                                            label = `${label} - ${suffix}`
                                            if(label == 'Home - FT') {
                                                
                                                this.flatodds.h_win = parseFloat(item.value)
                                            }
                                            else if(label == 'Away - FT') {
                                                this.flatodds.a_win = parseFloat(item.value)
                                            }
                                            else if(label == 'Draw - FT') {
                                                
                                                this.flatodds.d_win = parseFloat(item.value)
                                            }

                                            else if(label == "Over - 0.5 - FT")
                                                this.flatodds.o_05 = parseFloat(item.value)
                                            else if(label == "Over - 1.5 - FT")
                                                this.flatodds.o_15 = parseFloat(item.value)
                                            else if(label == "Over - 2.5 - FT")
                                                this.flatodds.o_25 = parseFloat(item.value)
                                            else if(label == "Over - 3.5 - FT")
                                                this.flatodds.o_35 = parseFloat(item.value)

                                            else if(label == "Under - 0.5 - FT")
                                                this.flatodds.u_05 = parseFloat(item.value)
                                            else if(label == "Under - 1.5 - FT")
                                                this.flatodds.u_15  = parseFloat(item.value)
                                            else if(label == "Under - 2.5 - FT")
                                                this.flatodds.u_25  = parseFloat(item.value)
                                            else if(label == "Under - 3.5 - FT")
                                                this.flatodds.u_35  = parseFloat(item.value)

                                            else if(label == "BTS - FT")
                                                this.flatodds.bts_yes  = parseFloat(item.value)
                                            else if(label == "No BTS - FT")
                                                this.flatodds.bts_no = parseFloat(item.value)

                                            else if(label == "Over - 0.5 - HT")
                                                this.flatodds.o_05_ht = parseFloat(item.value)
                                            else if(label == "Under - 0.5 - HT")
                                                this.flatodds.u_05_ht = parseFloat(item.value)
                                        }
                                    });
                                }
                            });
                            var oddslines = null;
                            if ( seasonData.league5yearsStats.length > 0 ) {
                                oddslines = seasonData.league5yearsStats[0].oddslines;                            

                                var odds = null;
                                let home_odds = 100;
                                if (this.flatodds.h_win !== "-")
                                    home_odds = this.flatodds.h_win;
                                let away_odds = 100;
                                if (this.flatodds.a_win !== "-")
                                    away_odds = this.flatodds.a_win;
                                
                                if (home_odds <= 3 && away_odds <= 3) {
                                    odds = oddslines[3]
                                }
                                else if (home_odds <= 1.5) {
                                    odds = oddslines[0]
                                }
                                else if (home_odds > 1.5 && home_odds <= 2) {
                                    odds = oddslines[1]
                                }
                                else if (home_odds > 2 && home_odds <= 3) {
                                    odds = oddslines[2]
                                }
                                
                                else if (away_odds <= 1.5) {
                                    odds = oddslines[4]
                                }
                                else if (away_odds > 1.5 && away_odds <= 2) {
                                    odds = oddslines[5]
                                }
                                else if (away_odds > 2 && away_odds <= 3) {
                                    odds = oddslines[6]
                                }
                                
                                if (odds) {
                                    this.flatodds.prob_home = parseInt(odds.home_win_percent)
                                    this.flatodds.prob_draw = parseInt(odds.draw_win_percent)
                                    this.flatodds.prob_away = parseInt(odds.away_win_percent)
                                    this.flatodds.prob_over05 = parseInt(odds.full_05_percent)
                                    this.flatodds.prob_over15 = parseInt(odds.full_15_percent)
                                    this.flatodds.prob_over25 = parseInt(odds.full_25_percent)
                                    this.flatodds.prob_over35 = parseInt(odds.full_35_percent)
                                    this.flatodds.prob_bts = parseInt(odds.bts_percent)
                                    this.flatodds.prob_over05_ht = parseInt(odds.first_05_percent)

                                    this.flatodds.prob_under05 = 100 - parseInt(odds.full_05_percent)
                                    this.flatodds.prob_under15 = 100 - parseInt(odds.full_15_percent)
                                    this.flatodds.prob_under25 = 100 - parseInt(odds.full_25_percent)
                                    this.flatodds.prob_under35 = 100 - parseInt(odds.full_35_percent)

                                    this.flatodds.prob_bts_no = 100 - parseInt(odds.bts_percent)
                                    this.flatodds.prob_under05_ht = 100 - parseInt(odds.first_05_percent)

                                    this.matches_sample = odds.total_matches;
                                }

                                if (this.flatodds.prob_home !== "-" && this.flatodds.h_win !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.h_win, this.flatodds.prob_home)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_home_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_home_tt2 = value.toFixed(2)                                    
                                }

                                if (this.flatodds.prob_draw !== "-" && this.flatodds.d_win !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.d_win, this.flatodds.prob_draw)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_draw_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_draw_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_away !== "-" && this.flatodds.a_win !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.a_win, this.flatodds.prob_away)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_away_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_away_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_over05 !== "-" && this.flatodds.o_05 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.o_05, this.flatodds.prob_over05)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_over05_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_over05_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_over15 !== "-" && this.flatodds.o_15 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.o_15, this.flatodds.prob_over15)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_over15_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_over15_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_over25 !== "-" && this.flatodds.o_25 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.o_25, this.flatodds.prob_over25)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_over25_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_over25_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_over35 !== "-" && this.flatodds.o_35 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.o_35, this.flatodds.prob_over35)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_over35_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_over35_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_under05 !== "-" && this.flatodds.u_05 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.u_05, this.flatodds.prob_under05)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_under05_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_under05_tt2 = value.toFixed(2)
                                }
                                if (this.flatodds.prob_under15 !== "-" && this.flatodds.u_15 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.u_15, this.flatodds.prob_under15)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_under15_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_under15_tt2 = value.toFixed(2)
                                }
                                if (this.flatodds.prob_under25 !== "-" && this.flatodds.oddsu_25_under25 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.u_25, this.flatodds.prob_under25)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_under25_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_under25_tt2 = value.toFixed(2)
                                }
                                if (this.flatodds.prob_under35 !== "-" && this.flatodds.u_35 !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.u_35, this.flatodds.prob_under35)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_under35_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_under35_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_over05_ht !== "-" && this.flatodds.o_05_ht !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.o_05_ht, this.flatodds.prob_over05_ht)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_over05_ht_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_over05_ht_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_under05_ht !== "-" && this.flatodds.u_05_ht !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.u_05_ht, this.flatodds.prob_under05_ht)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_under05_ht_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_under05_ht_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_bts !== "-" && this.flatodds.bts_yes !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.bts_yes, this.flatodds.prob_bts)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_bts_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_bts_tt2 = value.toFixed(2)
                                }

                                if (this.flatodds.prob_bts_no !== "-" && this.flatodds.bts_no !== "-") {
                                    var val = this.get_trueodds_value(this.flatodds.bts_no, this.flatodds.prob_bts_no)
                                    var true_odd = val[0]
                                    var value = val[1]
                                    this.flatodds.prob_bts_no_tt1 = true_odd.toFixed(2)
                                    this.flatodds.prob_bts_no_tt2 = value.toFixed(2)
                                }
                            }
                        }

                        if (this.matches_sample == 0) {
                            this.flatodds = {
                                "h_win": "-",
                                "a_win": "-",
                                "d_win": "-",
                                "o_05": "-",
                                "o_15": "-",
                                "o_25": "-",
                                "o_35": "-",
                                "u_05": "-",
                                "u_15": "-",
                                "u_25": "-",
                                "u_35": "-",
                                "o_05_ht": "-",
                                "u_05_ht": "-",
                                "bts_yes": "-",
                                "bts_no": "-",
                                prob_home: "-",
                                prob_draw: "-",
                                prob_away : "-",
                                prob_over05: "-",
                                prob_over15: "-",
                                prob_over25 : "-",
                                prob_over35 : "-",
                                prob_bts: "-",
                                prob_over05_ht: "-",

                                prob_under05: "-",
                                prob_under15: "-",
                                prob_under25 : "-",
                                prob_under35: "-",

                                prob_bts_no: "-",
                                prob_under05_ht: "-",

                                prob_home_tt1: null,
                                prob_home_tt2: null,
                                prob_away_tt1: null,
                                prob_away_tt2: null,
                                prob_draw_tt1: null,
                                prob_draw_tt2: null,
                                prob_over05_tt1: null,
                                prob_over05_tt2: null,
                                prob_over15_tt1: null,
                                prob_over15_tt2: null,
                                prob_over25_tt1: null,
                                prob_over25_tt2: null,
                                prob_over35_tt1: null,
                                prob_over35_tt2: null,
                                prob_under05_tt1: null,
                                prob_under05_tt2: null,
                                prob_under15_tt1: null,
                                prob_under15_tt2: null,
                                prob_under25_tt1: null,
                                prob_under25_tt2: null,
                                prob_under35_tt1: null,
                                prob_under35_tt2: null,
                                prob_over05_ht_tt1: null,
                                prob_over05_ht_tt2: null,
                                prob_under05_ht_tt1: null,
                                prob_under05_ht_tt2: null,
                                prob_bts_tt1: null,
                                prob_bts_tt2: null,
                                prob_bts_no_tt1: null,
                                prob_bts_no_tt2: null,

                            };
                        }
                    
                    }
                    // let rtgTime = []
                    // let homeRS = []
                    // let awayRS = []

                    // if (seasonData.liveStatsT.length > 0) {
                    //     let home_rtg_stats = seasonData.liveStatsT[0].home_rtg_stats
                    //     let away_rtg_stats = seasonData.liveStatsT[0].away_rtg_stats
                    //     if(home_rtg_stats){
                    //         for(let c = 0; c < home_rtg_stats.length; c++){
                    //             let minute = home_rtg_stats[c].time.minute
                    //             let half_extra_time = 0;
                    //             let home_rtg = {
                    //                 'on': null,
                    //                 'off': null,
                    //                 'cnr': null,
                    //                 'da': null,
                    //                 'goal': null,
                    //                 'rtg': null
                    //             }

                    //             if(home_rtg_stats[c].time.extra_time != null){
                    //                 minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                    //                 if(home_rtg_stats[c].time.minute < 46){
                    //                     half_extra_time = home_rtg_stats[c].time.extra_time
                    //                 }
                    //             }
                    //             if(home_rtg_stats[c].time.minute > 45){
                    //                 minute = minute + half_extra_time
                    //             }
                    //             rtgTime.push(minute)

                    //             if(c <= 10){
                    //                 if(home_rtg_stats[c].shots != null){
                    //                     home_rtg.on = home_rtg_stats[c].shots.ongoal
                    //                     home_rtg.off = home_rtg_stats[c].shots.offgoal
                    //                 }
                    //                 if(home_rtg_stats[c].da != null){
                    //                     home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                    //                 }
                    //                 home_rtg.cnr = home_rtg_stats[c].cnr
                    //                 home_rtg.goal = home_rtg_stats[c].goals
                    //             }
                    //             else{
                    //                 if(home_rtg_stats[c - 10].shots != null){
                    //                     home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                    //                     home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                    //                 }
                    //                 if(home_rtg_stats[c - 10].da != null){
                    //                     home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                    //                 }
                    //                 home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                    //                 home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                    //             }

                    //             if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                    //                 home_rtg.rtg = 0
                    //                 if(home_rtg.on >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                    //                 }
                    //                 if(home_rtg.off >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                    //                 }
                    //                 if(home_rtg.cnr >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                    //                 }
                    //                 if(home_rtg.da >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.da
                    //                 }
                    //             }
                    //             else{
                    //                 home_rtg.rtg = '-'
                    //             }
                    //             homeRS.push(home_rtg.rtg)
                    //         }
                    //     }
                    //     if(away_rtg_stats){
                    //         for(let c = 0; c < away_rtg_stats.length; c++){
                    //             let home_rtg = {
                    //                 'on': null,
                    //                 'off': null,
                    //                 'cnr': null,
                    //                 'da': null,
                    //                 'goal': null,
                    //                 'rtg': null
                    //             }
                    //             if(c <= 10){
                    //                 if(away_rtg_stats[c].shots != null){
                    //                     home_rtg.on = away_rtg_stats[c].shots.ongoal
                    //                     home_rtg.off = away_rtg_stats[c].shots.offgoal
                    //                 }
                    //                 if(away_rtg_stats[c].da != null){
                    //                     home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                    //                 }
                    //                 home_rtg.cnr = away_rtg_stats[c].cnr
                    //                 home_rtg.goal = away_rtg_stats[c].goals
                    //             }
                    //             else{
                    //                 if(away_rtg_stats[c - 10].shots != null){
                    //                     home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                    //                     home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                    //                 }
                    //                 if(away_rtg_stats[c - 10].da != null){
                    //                     home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                    //                 }
                    //                 home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                    //                 home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                    //             }

                    //             if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                    //                 home_rtg.rtg = 0
                    //                 if(home_rtg.on >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                    //                 }
                    //                 if(home_rtg.off >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                    //                 }
                    //                 if(home_rtg.cnr >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                    //                 }
                    //                 if(home_rtg.da >= 0){
                    //                     home_rtg.rtg = home_rtg.rtg + home_rtg.da
                    //                 }
                    //             }
                    //             else{
                    //                 home_rtg.rtg = '-'
                    //             }
                    //             awayRS.push(-home_rtg.rtg)
                    //         }
                    //     }
                    // }

                    // for(let i = 0 ; i < this.eventArray.length ; i++){
                    //     for(let j = 0 ; j < this.eventArray[i].events.length ; j++){
                    //         console.log('===>', this.eventArray[i].events[j].home.id, this.eventArray[i].events[j].away.id)
                    //         if(this.eventArray[i].events[j].home.id == home_id && this.eventArray[i].events[j].away.id == away_id){
                    //             this.historicModalData.home_season = Object.assign(home_season)
                    //             this.historicModalData.away_season = Object.assign(away_season)
                    //             this.historicModalData.home_p = home_p
                    //             this.historicModalData.away_p = away_p
                    //             // this.data[0].x = this.eventArray[i].events[j].chart.time
                    //             // this.data[1].x = this.eventArray[i].events[j].chart.time
                    //             // this.data[0].y = this.eventArray[i].events[j].chart.homeRTG
                    //             // this.data[1].y = this.eventArray[i].events[j].chart.awayRTG
                    //             this.data[0].x = rtgTime
                    //             this.data[1].x = rtgTime
                    //             this.data[0].y = homeRS
                    //             this.data[1].y = awayRS

                    //             this.data[0].name = this.eventArray[i].events[j].main_data.home_name
                    //             this.data[1].name = this.eventArray[i].events[j].main_data.away_name
                    //             this.historicModalData.eventName = this.eventArray[i].events[j].main_data.home_name + " v " + this.eventArray[i].events[j].main_data.away_name
                    //             // this.eventArray[i].events[j].show = true
                    //         }
                    //     }
                    // }
                    // for(let i = 0 ; i < this.finishedArray.length ; i++){
                    //     for(let j = 0 ; j < this.finishedArray[i].events.length ; j++){
                    //         console.log('===>', this.finishedArray[i].events[j].home.id, this.finishedArray[i].events[j].away.id)
                    //         if(this.finishedArray[i].events[j].home.id == home_id && this.finishedArray[i].events[j].away.id == away_id){
                    //             this.historicModalData.home_season = Object.assign(home_season)
                    //             this.historicModalData.away_season = Object.assign(away_season)
                    //             this.historicModalData.home_p = home_p
                    //             this.historicModalData.away_p = away_p
                    //             // this.data[0].x = this.finishedArray[i].events[j].chart.time
                    //             // this.data[1].x = this.finishedArray[i].events[j].chart.time
                    //             // this.data[0].y = this.finishedArray[i].events[j].chart.homeRTG
                    //             // this.data[1].y = this.finishedArray[i].events[j].chart.awayRTG

                    //             this.data[0].x = rtgTime
                    //             this.data[1].x = rtgTime
                    //             this.data[0].y = homeRS
                    //             this.data[1].y = awayRS

                    //             this.data[0].name = this.finishedArray[i].events[j].main_data.home_name
                    //             this.data[1].name = this.finishedArray[i].events[j].main_data.away_name
                    //             this.historicModalData.eventName = this.finishedArray[i].events[j].main_data.home_name + " v " + this.finishedArray[i].events[j].main_data.away_name
                    //             // this.eventArray[i].events[j].show = true
                    //         }
                    //     }
                    // }

                    let home = {
                        'id': 0,
                        'on': null,
                        'off': null,
                        'blk': null,
                        'in': null,
                        'out': null,
                        'cnr': null,
                        'da': null,
                        'goal': null,
                        'rtg': 0,
                        'gdr':0,
                        'time': '',
                        'score': 0,
                        'flash': 0,
                        'poss': null,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': null,
                        'red': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'last_on': 0,
                        'last_off': 0,
                        'last_cnr': 0,
                        'last_da': 0,
                        'last_goal': 0,
                        'a_rtg': 14
                    }
                    let homeT = {
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'flash': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'red': 0,
                        'yel': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'nxt': 0,
                        'rtg': 0,
                    }
                    let away = {
                        'id': 0,
                        'on': null,
                        'off': null,
                        'blk': null,
                        'in': null,
                        'out': null,
                        'cnr': null,
                        'da': null,
                        'goal': null,
                        'rtg': 0,
                        'gdr': 0,
                        'time': 0,
                        'score': 0,
                        'poss': null,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': null,
                        'red': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'last_on': 0,
                        'last_off': 0,
                        'last_cnr': 0,
                        'last_da': 0,
                        'last_goal': 0,
                        'a_rtg': 14
                    }
                    let awayT = {
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'red': 0,
                        'yel': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'nxt': 0,
                        'rtg': 0
                    }

                    if(seasonData.home_season){
                        if(seasonData.home_season.p > 0){
                            home.gdr = 0
                            homeT.rtg = 0
                            if(seasonData.home_season.on > 0){
                                home.last_on = seasonData.home_season.on/seasonData.home_season.p
                            }
                            if(seasonData.home_season.off > 0){
                                home.last_off = seasonData.home_season.off/seasonData.home_season.p
                            }
                            if(seasonData.home_season.cnr > 0){
                                home.last_cnr = seasonData.home_season.cnr/seasonData.home_season.p
                            }
                            if(seasonData.home_season.da > 0){
                                home.last_da = seasonData.home_season.da/seasonData.home_season.p
                            }
                            if(seasonData.home_season.goals > 0){
                                home.last_goal = seasonData.home_season.goals/seasonData.home_season.p
                            }
                            //----------average rtg-----------
                            home.a_rtg = 0
                            if(home.last_on > 0){
                                home.a_rtg = home.a_rtg + (home.last_on/9)*3
                            }
                            if(home.last_off > 0){
                                home.a_rtg = home.a_rtg + (home.last_off/9)*2
                            }
                            if(home.last_cnr > 0){
                                home.a_rtg = home.a_rtg + (home.last_cnr/9)
                            }
                            if(home.last_da > 0){
                                home.a_rtg = home.a_rtg + (home.last_da/9)
                            }
                            //--------------------------------

                            if(home.last_goal > 0 && home.last_on > 0){
                                home.gdr = home.gdr + ((100*home.on/home.last_goal/home.last_on/9)*home.on)
                            }
                            if(home.last_goal > 0 && home.last_off > 0){
                                home.gdr = home.gdr + ( ( 100*home.off/home.last_goal/home.last_off/ 9 )*home.off )
                            }
                            if(home.last_goal > 0 && home.last_cnr > 0){
                                home.gdr = home.gdr + ((100*home.cnr/home.last_goal/home.last_cnr/9)*home.cnr )
                            }
                            if(home.last_goal > 0 && home.last_da > 0){
                                home.gdr = home.gdr + ((100*home.da/home.last_goal/home.last_da/9)*home.da )
                            }
                            home.gdr = home.gdr.toFixed(0)

                            // if(home_goal === 0){
                            //     homeT.nxt = 0
                            //     if(home.last_goal > 0 && home.last_on > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home.last_goal/home.last_goal)))
                            //     }
                            //     if(home.last_goal > 0 && home.last_off > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home.last_goal/home.last_goal)))
                            //     }
                            //     if(home.last_goal > 0 && home.last_cnr > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home.last_goal/home.last_goal)))
                            //     }
                            //     if(home.last_goal > 0 && home.last_da > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home.last_goal/home.last_goal)))
                            //     }
                            //     homeT.nxt = (homeT.nxt*100/4).toFixed(0)
                            //     homeT.nxt = -1 * homeT.nxt
                            // }
                            // else if(home_goal > 0){
                            //     homeT.nxt = 0
                            //     if(home.last_goal > 0 && home.last_on > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home_goal/home.last_goal)))
                            //     }
                            //     if(home.last_goal > 0 && home.last_off > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home_goal/home.last_goal)))
                            //     }
                            //     if(home.last_goal > 0 && home.last_cnr > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home_goal/home.last_goal)))
                            //     }
                            //     if(home.last_goal > 0 && home.last_da > 0){
                            //         homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home_goal/home.last_goal)))
                            //     }
                            //     homeT.nxt = (homeT.nxt*100/4 - 100).toFixed(0)
                            //     homeT.nxt = -1 * homeT.nxt
                            // }

                            // if(home_goal > 0){
                            //     if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                            //         homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                            //     }
                            //     if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                            //         homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                            //     }
                            //     if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                            //         homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                            //     }
                            //     if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                            //         homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                            //     }
                            //     if(tot_time > 0 && home.last_goal > 0){
                            //         homeT.rtg = homeT.rtg + home_goal*90/tot_time/home.last_goal
                            //     }
                            //     homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                            // }
                            // else{
                            //     if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                            //         homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                            //     }
                            //     if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                            //         homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                            //     }
                            //     if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                            //         homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                            //     }
                            //     if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                            //         homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                            //     }
                            //     homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                            // }
                        }
                    }

                    if(seasonData.away_season){
                        if(seasonData.away_season.p > 0){
                            away.gdr = 0
                            awayT.rtg = 0
                            if(seasonData.away_season.on > 0){
                                away.last_on = seasonData.away_season.on/seasonData.away_season.p
                            }
                            if(seasonData.away_season.off > 0){
                                away.last_off = seasonData.away_season.off/seasonData.away_season.p
                            }
                            if(seasonData.away_season.cnr > 0){
                                away.last_cnr = seasonData.away_season.cnr/seasonData.away_season.p
                            }
                            if(seasonData.away_season.da > 0){
                                away.last_da = seasonData.away_season.da/seasonData.away_season.p
                            }
                            if(seasonData.away_season.goals > 0){
                                away.last_goal = seasonData.away_season.goals/seasonData.away_season.p
                            }

                            if(away.last_goal > 0 && away.last_on > 0){
                                away.gdr = away.gdr + ((100*away.on/away.last_goal/away.last_on/9)*away.on)
                            }
                            if(away.last_goal > 0 && away.last_off > 0){
                                away.gdr = away.gdr + ( ( 100*away.off/away.last_goal/away.last_off/ 9 )*away.off )
                            }
                            if(away.last_goal > 0 && away.last_cnr > 0){
                                away.gdr = away.gdr + ((100*away.cnr/away.last_goal/away.last_cnr/9)*away.cnr )
                            }
                            if(away.last_goal > 0 && away.last_da > 0){
                                away.gdr = away.gdr + ((100*away.da/away.last_goal/away.last_da/9)*away.da )
                            }
                            away.gdr = away.gdr.toFixed(0)

                            //---------------away average rtg-------------------
                            away.a_rtg = 0
                            if(away.last_on > 0){
                                away.a_rtg = away.a_rtg + (away.last_on/9)*3
                            }
                            if(away.last_off > 0){
                                away.a_rtg = away.a_rtg + (away.last_off/9)*2
                            }
                            if(away.last_cnr > 0){
                                away.a_rtg = away.a_rtg + (away.last_cnr/9)
                            }
                            if(home.last_da > 0){
                                away.a_rtg = away.a_rtg + (away.last_da/9)
                            }
                            //----------------------------------------------

                            // if(away_goal === 0){
                            //     awayT.nxt = 0
                            //     if(away.last_goal > 0 && away.last_on > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away.last_goal/away.last_goal)))
                            //     }
                            //     if(away.last_goal > 0 && away.last_off > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away.last_goal/away.last_goal)))
                            //     }
                            //     if(away.last_goal > 0 && away.last_cnr > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away.last_goal/away.last_goal)))
                            //     }
                            //     if(away.last_goal > 0 && away.last_da > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away.last_goal/away.last_goal)))
                            //     }
                            //     awayT.nxt =(awayT.nxt*100/4).toFixed(0)
                            //     awayT.nxt = -1 * awayT.nxt
                            // }
                            // else if(away_goal > 0){
                            //     awayT.nxt = 0
                            //     if(away.last_goal > 0 && away.last_on > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away_goal/away.last_goal)))
                            //     }
                            //     if(away.last_goal > 0 && away.last_off > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away_goal/away.last_goal)))
                            //     }
                            //     if(away.last_goal > 0 && away.last_cnr > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away_goal/away.last_goal)))
                            //     }
                            //     if(away.last_goal > 0 && away.last_da > 0){
                            //         awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away_goal/away.last_goal)))
                            //     }
                            //     awayT.nxt =(awayT.nxt*100/4 - 100).toFixed(0)
                            //     awayT.nxt = -1 * awayT.nxt
                            // }

                            // if(away_goal > 0){
                            //     if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                            //         awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                            //     }
                            //     if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                            //         awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                            //     }
                            //     if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                            //         awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                            //     }
                            //     if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                            //         awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                            //     }
                            //     if(tot_time > 0 && away.last_goal > 0){
                            //         awayT.rtg = awayT.rtg + away_goal*90/tot_time/away.last_goal
                            //     }
                            //     awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                            // }
                            // else{
                            //     if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                            //         awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                            //     }
                            //     if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                            //         awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                            //     }
                            //     if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                            //         awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                            //     }
                            //     if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                            //         awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                            //     }
                            //     awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                            // }
                        }
                    }

                    this.historicModalData.home_season = Object.assign(home_season)
                    this.historicModalData.away_season = Object.assign(away_season)
                    this.historicModalData.home_p = home_p
                    this.historicModalData.away_p = away_p

                    this.historicModalData.home_a_rtg = home.a_rtg;
                    this.historicModalData.away_a_rtg = away.a_rtg;

                    console.log('setted')

                    this.isload = true;
                    console.log(seasonData.DailyFixtures[0].trends.data)


                    let h_on_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'on_target', seasonData.localTeamId);
                    this.h_on_tooltip = h_on_result[0];
                    this.h_on = h_on_result[1];
                    this.h_onKey = this.create_UUID();

                    let h_off_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'off_target', seasonData.localTeamId);
                    this.h_off_tooltip = h_off_result[0];
                    this.h_off = h_off_result[1];
                    this.h_offKey = this.create_UUID();

                    let h_cnr_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'corners', seasonData.localTeamId);
                    this.h_cnr_tooltip = h_cnr_result[0];
                    this.h_cnr = h_cnr_result[1];
                    this.h_cnrKey = this.create_UUID();

                    let h_dak_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'dangerous_attacks', seasonData.localTeamId);
                    this.h_dak_tooltip = h_dak_result[0];
                    this.h_dak = h_dak_result[1];
                    this.h_dakKey = this.create_UUID();

                    let h_pos_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'possession', seasonData.localTeamId);
                    this.h_pos_tooltip = '';
                    this.h_pos = h_pos_result[1];
                    this.h_posKey = this.create_UUID();

                    let h_red_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'redcards', seasonData.localTeamId);
                    this.h_red_tooltip = h_red_result[0];
                    this.h_red = h_red_result[1];
                    this.h_redKey = this.create_UUID();

                    let h_yel_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'yellowcards', seasonData.localTeamId);
                    this.h_yel_tooltip = h_yel_result[0];
                    this.h_yel = h_yel_result[1];
                    this.h_yelKey = this.create_UUID();

                    let h_goals_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'goals', seasonData.localTeamId);
                    this.h_goals_tooltip = h_goals_result[0];
                    this.h_goals = h_goals_result[1];
                    this.h_goalsKey = this.create_UUID();

                    console.log(seasonData.events1.data)
                    let h_sbst_result = this.checkEvents1(seasonData.events1.data, 'substitution', seasonData.localTeamId);
                    this.h_sbst_tooltip = h_sbst_result[0];
                    this.h_sbst = h_sbst_result[1]
                    this.h_sbstKey = this.create_UUID();

                    let a_on_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'on_target', seasonData.visitorTeamId);
                    this.a_on_tooltip = a_on_result[0];
                    this.a_on = a_on_result[1];
                    this.a_onKey = this.create_UUID();

                    let a_off_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'off_target', seasonData.visitorTeamId);
                    this.a_off_tooltip = a_off_result[0];
                    this.a_off = a_off_result[1];
                    this.a_offKey = this.create_UUID();

                    let a_cnr_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'corners', seasonData.visitorTeamId);
                    this.a_cnr_tooltip = a_cnr_result[0];
                    this.a_cnr = a_cnr_result[1];
                    this.a_cnrKey = this.create_UUID();

                    let a_dak_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'dangerous_attacks', seasonData.visitorTeamId);
                    this.a_dak_tooltip = a_dak_result[0];
                    this.a_dak = a_dak_result[1];
                    this.a_dakKey = this.create_UUID();

                    let a_pos_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'possession', seasonData.visitorTeamId);
                    this.a_pos_tooltip = '';
                    this.a_pos = a_pos_result[1];
                    this.a_posKey = this.create_UUID();

                    let a_red_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'redcards', seasonData.visitorTeamId);
                    this.a_red_tooltip = a_red_result[0];
                    this.a_red = a_red_result[1];
                    this.a_redKey = this.create_UUID();

                    let a_yel_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'yellowcards', seasonData.visitorTeamId);
                    this.a_yel_tooltip = a_yel_result[0];
                    this.a_yel = a_yel_result[1];
                    this.a_yelKey = this.create_UUID();

                    let a_goals_result = this.checkAnalyses(seasonData.DailyFixtures[0].trends.data, 'goals', seasonData.visitorTeamId);
                    this.a_goals_tooltip = a_goals_result[0];
                    this.a_goals = a_goals_result[1];
                    this.a_goalsKey = this.create_UUID();

                    let a_sbst_result = this.checkEvents1(seasonData.events1.data, 'substitution', seasonData.visitorTeamId);
                    this.a_sbst_tooltip = a_sbst_result[0];
                    this.a_sbst = a_sbst_result[1]
                    this.a_sbstKey = this.create_UUID();

                    this.percallfunction()
                })
            },
            checkEvents1(data, onTarget, team_id) {
                var min_tooltip = '';
                var amount = 0;

                for (var t_index = 0; t_index < data.length; t_index++) {
                    if (data[t_index].type != onTarget || data[t_index].team_id != team_id)
                        continue
                    var minute = parseInt(data[t_index].minute);

                   
                    min_tooltip = min_tooltip + " " + minute + "'";
                    amount += 1;
                }

                return [ min_tooltip, amount ];
            },
            checkAnalyses(trendsData, onTarget, team_id) {
                var min_tooltip = ''
                var amount = "-"
                var old_amount = 0
                var old_minute = 0

                if (trendsData.length !== 0) {
                    var trends = trendsData.filter(item => item.type == onTarget && item.team_id == team_id);                
                    if (trends.length !== 0) {
                        var analyses = trends[0].analyses;

                        for (var t_index = 0; t_index < analyses.length; t_index++) {
                            var minute = parseInt(analyses[t_index].minute);
                            
                            if (minute === 0)
                                continue;
                            if (parseInt(analyses[t_index].amount) === 0)
                                continue;

                            if (parseInt(analyses[t_index].amount) == old_amount)
                                continue;

                            if (parseInt(analyses[t_index].amount) < old_amount) {                                
                                continue;
                            }

                            if (t_index < (analyses.length - 1)) {
                                if (parseInt(analyses[t_index].amount) > parseInt(analyses[t_index + 1].amount))
                                    continue;
                            }

                            
                            min_tooltip = min_tooltip + " " + minute + "'";
                            amount = parseInt(analyses[t_index].amount);

                            if (onTarget != 'possession' && (amount - old_amount) > 1) {
                                min_tooltip = min_tooltip + '('+ (amount - old_amount).toString() + ')';
                            }
                            old_amount = amount;
                            old_minute = minute;
                        }
                    }
                }
                return [ min_tooltip, amount ];
            }
        },
        mounted() {
            if (!this.ref_numOfAttempt)
                this.ref_numOfAttempt = 1;
            if (!this.cover_ref_numOfAttempt)
                this.cover_ref_numOfAttempt = 1;

            if (this.item.fixture && this.item.fixture.length > 0)
                this.calcCashOut();
        },
        updated() {
            // this.calcCashOut();
        }
    }
</script>

<style lang="scss" scoped>
    .cash_out_cell {
        margin-top: auto;
        margin-bottom: auto;
    }
    .settled-lost {
        font-weight: 700;
        color: #FF0000;
    }

    .settled-won {
        font-weight: 700;
        color: #00FF00;
    }

    .settled-void {
        font-weight: 700;
        color: #0000FF;
    }
    .auto_cashout {
        font-weight: normal;
        float: right;
        padding-right: 53px;
        color: blue;
    }
    .auto_cashout:hover {
        
        cursor: pointer;
    }
    .comments_btn {
        color: blue;
    }
    .comments_btn:hover {
        
        cursor: pointer;
    }

    .posted_date {
        text-align: end;
    }

    .second_line_left_hidden {
        display: none !important;
    }

    .horizon_line {
        color: #d3d3d3;
        height: 1px;
    }

    .feed_page_second_line {
        display: flex;
        flex-wrap: wrap;
        /* justify-content: start; */

    }

    .avatar_container {
        display: block !important;
        text-align: center !important;
        margin-left: 50px;
        border-right: 1px solid #d3d3d3;
        padding: 20px;
    }

    .feed_avatar {
        padding: 0;

    }

    .post-comment > input{
        background-color: #fffaf0 !important;
    }

    .post-card {
        .header {
            .header-item {
                display: flex;
                justify-content: space-between;
                position: relative;

                div {
                    display: flex;
                }
            }
        }

        .unread-mark {
            top: 0px;
            left: 0px;
        }

        .note-box {
            position: relative;
            padding: 5px;
            background-color: whitesmoke;
            border-radius: 5px;
            margin-top: 10px;

            .note {
                padding: 5px;
                margin: 0 0 10px;
                min-height: 20px;
                padding-bottom: 0;
            }
        }

        .comments {
            padding: 0 0 0 40px;

            .comment {
                position: relative;

                .comment-header {
                    display: flex;
                    align-items: center;

                    .vue-avatar--wrapper {
                        margin-right: 15px;
                    }
                }

                p {
                    padding-left: 45px;
                }
            }
        }

        .post-comment {
            text-align: right;
            margin-bottom: 10px;

            .btn {}
        }
    }

    .comment_area {
        padding: 8px 35px !important;
        border: 1px solid #deddda;
        background-color: #fffaf0;
        border-radius: 7px;
        margin-left: 30px;
        max-width: 100%;
        display: inline-block;
    }

    .posted_date_mb{
       text-align: end;
    }
    .second_line_right{
        width: 75%;
        padding: 20px;
        margin-right: 0 !important;
        background-color: white;
        border-radius: 5px;
        border: none;
    }
    .sub_post_comment > .form-control{
        background-color: blue !important;
    }

    .avatar_link, .avatar_link_under{
        font-size: 18px;
        font-weight: bold;
    }
    .bold_head{
        font-size: 20px;
    }
    .tips_font18{
        font-size: 18px;
    }
    .right_bottom{
        font-size: 16px;
        margin-top: 10px;
        padding: 5px;
        background-color: whitesmoke;
        border-radius: 5px;
    }
    .hr_underpost{
        background-color: #a4c1c4;
    }
    .cash_out_details{
        font-weight: bold;
    }
    .parent_cash_out_details{
        padding: 5px;
        background-color: whitesmoke;
        margin-top: 5px;
        border-radius: 5px;
    }
    .comments_button_box{
        background-color: white;
        padding: 10px;
        border-radius: 5px;
        width: 100%;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .note_letters{
        margin-bottom: 0;
        font-weight: bold;
    }
    @media (min-width: 576px) {
        .desktop_hide{
            display: none;
        }
    }
    @media (max-width: 576px) {
        .comments_button{
            min-width: 50px;
        }
        .hr_underpost{
            display: none;
        }
        .modile_hide {
            display: none;
        }
        .note_letters{
            font-size: 14px;
            font-weight: bold;
            margin-bottom: 0 !important;
            padding-bottom: 0;
        }
        .bold_head{
            font-size: 14px;
        }
        .tips_font18{
            font-size: 12px;
        }
        .cash_out_details{
            font-size: 14px;
        }
        .right_bottom{
            font-size: 14px;
        }
        .right_bottom > div{
            margin-top: 5px;
        }
        .feed_page_second_line{
            display: block;
        }
        .second_line_right{
            width: 100%;
            padding: 10px;
        }
        .horizon_line{
            margin-bottom: 0;
        }
       
        .avatar_right_letters{
            display: block !important;
            text-align: center;
        }
        .avatar_right_letters > a{
            margin-left: 10px;
            font-weight: 700 !important;
            font-size: 15px !important;
        }
        .posted_date_mb{
            font-size: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
        }
        .post-card{
            font-size: 12px !important;
            letter-spacing: -0.7;
        }
        .cashout_button{
            font-size: 11.5px !important;
            height: 23px;
            
        }
        
        .second_line_left_hidden{
            display: flex !important;
            align-items: center;
        }
        .second_line_left {
            display: none !important;
        }
        .delete_tip {
            font-size: 25px;
            
        }
        .delete_comment {
            font-size: 25px;
        }
    }

    .delete_tip {
        
        font-size: 30px;
        float: right;
        margin-left: 20px;
        margin-top: -15px;
        color: red;
        font-weight: 900;
    }

    .delete_comment {
        
        margin-top: -5px;
        font-size: 30px;
        color: red;
        font-weight: 900;
    }

    .cashout_button{
        white-space: nowrap;
        text-align: center;
    }

    .online-mark {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-color: green;
        border-radius: 50%;
        margin-right: 3px;
    }
    .offline-mark {
        width: 10px;
        height: 10px;
        display: inline-block;
        background-color: #bec0c2;
        border-radius: 50%;
        margin-right: 3px;
    }
</style>